import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=27294dd7&scoped=true&"
import script from "./dynamic.js?vue&type=script&lang=js&"
export * from "./dynamic.js?vue&type=script&lang=js&"
import style0 from "./dynamic.css?vue&type=style&index=0&id=27294dd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27294dd7",
  null
  
)

export default component.exports